var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2502 0C23.3829 0 10.5368 8.6521 4.47119 21.1957H72.029C65.9636 8.6521 53.1173 0 38.2502 0Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2502 74.9999C53.1173 74.9999 65.9636 66.3478 72.0292 53.8042H4.47119C10.5368 66.3478 23.3829 74.9999 38.2502 74.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2499 50.5434C45.4536 50.5434 51.2934 44.7036 51.2934 37.4999C51.2934 30.2963 45.4536 24.4565 38.2499 24.4565C31.0463 24.4565 25.2065 30.2963 25.2065 37.4999C25.2065 44.7036 31.0463 50.5434 38.2499 50.5434Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2498 45.6522C42.7521 45.6522 46.402 42.0024 46.402 37.5C46.402 32.9977 42.7521 29.3479 38.2498 29.3479C33.7475 29.3479 30.0977 32.9977 30.0977 37.5C30.0977 42.0024 33.7475 45.6522 38.2498 45.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 27.4404L40.7649 33.1442L46.9618 32.4703L43.2798 37.5001L46.9618 42.5299L40.7649 41.856L38.25 47.5598L35.735 41.856L29.5381 42.5298L33.2201 37.5001L29.5381 32.4703L35.735 33.1442L38.25 27.4404Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIndia);
export default __webpack_public_path__ + "static/media/flagIndia.ce7b7ba7dff5dad52293cb2d76dab166.svg";
export { ForwardRef as ReactComponent };